const en = {
  nav: {
    home: "Home",
    skillset: "Skillset",
    projects: "Projects",
    resume: "Resume",
    contact: "Contact Me",
  },
  themeToggle: {
    toDark: "Switch to dark mode",
    toLight: "Switch to light mode",
  },
  langToggle: {
    label: "Language",
  },
  preloader: {
    loading: "Loading",
  },
  home: {
    greeting: "Welcome to my portfolio!",
    intro: "I'm",
    name: "Thomorn, You Can Call Me Cyber-Mxrn",
    roles: [
      "Technical Support Fulltime",
      "Effective Problem Solver",
      "FullStack Web Developer",
      "UI/UX Designer",
      "ICT Teacher",
      "IT Support",
    ],
    tagline:
      "Bachelor's Degree in Information Technology Engineering from RUPP. Expertise in building web apps and exploring cybersecurity.",
    ctaProjects: "View my work",
    ctaContact: "Get in touch",
    photoAlt: "Thomorn",
    swapHint: "Hover or tap me",
    swapOn: "> access granted_",
    swapLabel: "Switch between my photo and my hacker avatar",
    scrollCue: "Scroll to explore",
  },
  about: {
    label: "Facts",
    heading: {
      a: "Let me",
      highlight: "introduce",
      b: "myself",
    },
    paragraphs: [
      "Hi, my name is Lao Thomorn and I was born in Phnom Penh. Currently, I'm living in Siem Reap, Cambodia.",

      "I hold a Bachelor's Degree in Information Technology Engineering (ITE) from the Royal University of Phnom Penh.",

      "I'm proficient in C, C++, Python, HTML, CSS, JavaScript, Sass, Node.js, React.js, Vue.js, PHP, Laravel, MySQL, MongoDB, SQLite, Firebase, Supabase, Git, GitHub, Flask, FastAPI, Tailwind CSS, Vite, Postman, and REST APIs — with additional knowledge of Java, GraphQL, Solidity, and modern web development tools.",

      "I have a strong passion for full-stack web development, especially building modern and responsive applications using React.js, Node.js, FastAPI, MongoDB, and other modern JavaScript technologies. I'm also interested in UI/UX design, responsive web design, and developing practical digital solutions.",

      "I'm also deeply interested in cybersecurity — especially ethical hacking, penetration testing, web security, and SOC-related technologies — and I enjoy learning about artificial intelligence and emerging technologies.",

      "Currently, I am an ICT Teacher at an organization in Siem Reap, where I teach young people practical ICT and digital skills, develop learning materials, assessments, and ICT activities. Alongside my teaching role, I also work as a Freelance Full-Stack Developer, building and improving web applications while continuing to develop my skills in modern technologies.",
    ],
    factsLabels: {
      location: "Location",
      role: "Role",
      focus: "Focus",
    },
    facts: {
      location: "Siem Reap, Cambodia",
      role: "Bachelor's Degree in Information Technology Engineering from RUPP; currently an ICT Teacher and Freelance Full-Stack Developer",
      focus:
        "Full-Stack Web Development, UI/UX Design, Cybersecurity, Technical Support, GPS Technical, and ICT Teaching",
    },
    cards: {
      available: "ICT Teacher · Freelance Dev",
      education: "Education",
      stack: "Tech stack",
      passion: "What drives me",
    },
    findMeOn: "Find me on",
    connectText: "Please don't hesitate to reach out to me and",
    connectHighlight: "connect.",
  },
  focus: {
    label: "Focus",
    heading: { a: "What I", highlight: "do" },
    marquee: ["React", "Node.js", "FastAPI", "Figma", "Laravel", "Vue.js", "MongoDB", "Tailwind CSS", "Python", "Cybersecurity", "UI/UX"],
    items: [
      { title: "Full-Stack Web Development", desc: "React, Node.js, FastAPI and Laravel apps" },
      { title: "UI/UX Design", desc: "Wireframes, prototypes and design systems in Figma" },
      { title: "Cybersecurity", desc: "Web security, ethical hacking and SOC basics" },
      { title: "ICT Teaching", desc: "Practical digital skills for young people" },
      { title: "Technical Support", desc: "Hardware, networks and troubleshooting" },
      { title: "Prototyping", desc: "From idea to a clickable demo, fast" },
    ],
  },
  skillset: {
    heading1: { a: "Professional", highlight: "Skillset" },
    heading2: { highlight: "Tools", b: "I use" },
    githubHeading: { a: "Days I", highlight: "Code" },
    githubSubheading:
      "Live contribution activity, pulled straight from my GitHub.",
    githubLinkText: "View GitHub profile",
  },
  projects: {
    label: "Feed",
    tags: { live: "Live Site", code: "Code", design: "UI/UX Design" },
    heading: { a: "Recent Top", highlight: "Works" },
    subheading: "Here are a few projects I've worked on recently.",
    footerNote:
      "Want to see more of my work? Check out my GitHub or any of my social media — thank you!",
    ghButton: "GitHub",
    demoButton: "Demo",
    items: {
      theWalk: {
        title: "TheWalk",
        description:
          "An e-commerce website built during my first semester of Year 3, where users can buy shoes online — similar to other e-commerce platforms.",
      },
      blogger: {
        title: "Blogger Website Blogs",
        description:
          "A blog I built on Blogger to upload assignments for my professors.",
      },
      fastapi: {
        title: "FastAPI Project",
        description:
          "A programming-project assignment from Year 2, built with FastAPI for my professor.",
      },
      meakutes: {
        title: "Meakutes Khmer",
        description:
          "A website where users can search for places to visit in Cambodia. The UI/UX is done; the build isn't finished yet — I plan to complete it by the end of the semester.",
      },
      walkFigma: {
        title: "TheWalk — Figma UI Concept (First Version)",
        description:
          "My Semester 1, Year 3 project at ITE. Our four-person team struggled to stay coordinated, so I changed plans and finished the design on my own.",
      },
      firstUiUx: {
        title: "My First UI/UX Design",
        description: "My very first Figma project, made while learning Figma.",
      },
      teacherAssistant: {
        title: "Teacher Assistant",
        description:
          "A web platform I built with a 5-person team using Vue.js integrated with the Laravel framework — check it out!",
      },
      car3d: {
        title: "Car3D Game",
        description: "A C++ project adapted from an overseas source.",
      },
      kroeungtes: {
        title: "KroeungTes UI/UX",
        description:
          "My Year 4 project for the Mobile Development (Semester 2) course.",
      },
      BookSelling: {
        title: "ReanPhysic",
        description:
          "The Website is a project that I built for my client that he want to create a website for his business. The website is built with React.js and Tailwind CSS, and it is hosted on Claudeflare & Render for Hosting Server.",
      },
      MyPortfolioWebsite: {
        title: "My Portfolio Website",
        description:
          "This is my personal portfolio website that I built to showcase my skills, projects, and experiences. It is built with React.js and Tailwind CSS, and it is hosted on Claudeflare.",
      },
      meakuteswebsitedemo: {
        title: "Meakutes Website Demo",
        description:
          "This is the website i build for promoting Cambodia Tourism in Covid-19 Era.",
      },
    },
  },
  resume: {
    downloadButton: "Download Resume",
    loadError: "Couldn't load the PDF preview — try the download button below.",
    loading: "Loading resume…",
  },
  contact: {
    heading: { a: "Get in", highlight: "touch" },
    lead: "Have a question or want to work together? Send me a message and I'll get back to you.",
    namePlaceholder: "Your name",
    emailPlaceholder: "Your email",
    messagePlaceholder: "Your message",
    sendButton: "Send message",
    notDone: "Please fill in all the fields.",
    done: "Thanks for reaching out! I've received your message.",
  },
  footer: {
    localTime: "Local time",
    location: "Siem Reap, Cambodia",
    cta: "Got a project in mind?",
    ctaLink: "Let's talk",
    madeWith: "Made with ☕ in Siem Reap",
    dept: "Department of Information Technology and Engineering",
    copyright: "Copyright ©",
  },
};

export default en;
